export const MESSAGES = {
  OPTION_NOT_INITIALIZED: '옵션 정보가 초기화되지 않았습니다',
  SELECT_UPPER_OPTION: '상위 옵션을 선택해 주세요',
  REQUIRED_INPUT_OPTION: '필수 옵션 정보를 입력해주세요',
  EXCEED_MAXIMUM_LIMIT: '상품의 최대구매수량을 초과합니다.',
  DUPLICATE_SELECTION: '동일한 옵션을 선택하여 수량을 추가합니다.',
  FIRST_ORDER_DISCOUNT: '첫구매 상품은 1개까지만 구매 가능합니다',
  STORE_DEAL_MAX_SELECTION: '100원딜 상품은 1개까지만 구매 가능합니다',
  RESTOCK_NOTIFICATION_FAILED: '재입고 알림 신청에 실패했습니다.\n다시 시도해주세요.',
  RESTOCK_NOTIFICATION_SUCCESS:
    '재입고 시 카카오톡과 푸시 알림으로 알려드릴게요.\n(전화번호가 없는 경우 푸시 알림만 발송됩니다.)',
  RESTOCK_NOTIFICATION_CANCELLED: '재입고 알림이 취소되었어요.',
  RESTOCK_NOTIFICATION_CANCELLED_TOAST: '알림이 취소되었습니다.',
  PRODUCT_ITEM_ID_NOT_FOUND: '상품 아이템 ID가 없습니다.',
  PRODUCT_ITEM_NOT_FOUND: '상품 아이템이 없습니다.',
  ORDER_SHEET_ERROR: '주문 중에 에러가 발생했습니다',
  UNKNOWN_ERROR: '알 수 없는 오류가 발생했습니다. 고객센터로 문의해주세요',
  ADD_TO_CART_SUCCESS: '장바구니에 상품을 담았습니다.',
} as const;
